<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.lockedRecordList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.setting.lockedRecordList')}}</div>
                        <!-- <b-button variant="primary" size="sm" class="float-right">Clear All</b-button> -->
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="lockedRecords.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.setting.entity')}}</th>
                                    <th>{{$t('form.setting.fieldID')}}</th>
                                    <th>{{$t('form.setting.editingBy')}}</th>
                                    <th>{{$t('form.setting.startedAt')}}</th>
                                    <th class="text-right">{{$t('form.setting.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(lockedRecord, index) in lockedRecords" v-bind:key="index">
                                <tr>
                                    <td>{{lockedRecord.form_name}}</td>
                                    <td>{{lockedRecord.field_id}}</td>
                                    <td>{{lockedRecord.user.name}}</td>
                                    <td>{{lockedRecord.created_at | formatDate(datetimeFormat)}}</td>
                                    <td class="text-right">
                                        <button class="btn btn-info btn btn-sm" @click="view(lockedRecord)"
                                            v-show="permissions.viewSettingsLockedrecords">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                        <button class="btn btn-danger btn btn-sm" @click="remove(index)"
                                            v-show="permissions.viewSettingsLockedrecords">
                                            <span class="fa fa-ban"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'datetimeFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },

                lockedRecords: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsLockedrecords) {
                this.$router.push('/');
                return;
            }

            this.getLockedRecord();
        },

        methods: {

            /**
             * Get Locked Records
             */
            getLockedRecord() {
                this.isLoading = true;
                axios
                    .get('/api/editformsessions?page=' + this.pagination.current_page)
                    .then(response => {
                        this.lockedRecords = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        // console.log(error.response);
                        this.isLoading = false;
                    });
            },

            /**
             * Pagination
             */
            paginate() {
                this.getLockedRecord();
            },

            /**
             * View Locked Record Entity
             */
            view(lockedRecord) {
                let name = '';

                if (lockedRecord.form_name == 'student') name = 'StudentEdit';
                else if (lockedRecord.form_name == 'alumni') name = 'AlumniEdit';
                else if (lockedRecord.form_name == 'professor') name = 'ProfessorEdit';
                else if (lockedRecord.form_name == 'staff') name = 'StaffEdit';
                else if (lockedRecord.form_name == 'program') name = 'ProgramEdit';
                else if (lockedRecord.form_name == 'company') name = 'CompanyEdit';
                else if (lockedRecord.form_name == 'course') name = 'CourseEdit';
                else if (lockedRecord.form_name == 'book') name = 'BookEdit';
                else if (lockedRecord.form_name == 'submission') name = 'SubmissionEdit';
                else if (lockedRecord.form_name == 'bookbundle') name = 'BookBundleEdit';
                else if (lockedRecord.form_name == 'studentinvoice') name = 'StudentInvoiceEdit';
                else if (lockedRecord.form_name == 'companyinvoice') name = 'CompanyInvoiceEdit';
                else if (lockedRecord.form_name == 'role') name = 'RoleEdit';
                else if (lockedRecord.form_name == 'user') name = 'UserEdit';
                else if (lockedRecord.form_name == 'partner') name = 'PartnerEdit';
                else if (lockedRecord.form_name == 'campus') name = 'CampusEdit';

                if (name == '') return;

                this.$router.push({
                    name: name,
                    params: {
                        id: lockedRecord.field_id
                    }
                });
            },

            /**
             * Remove Entity from Locked Record List
             */
            remove(index) {
                this.isLoading = true;
                
                let record = this.lockedRecords[index];

                axios
                    .delete('/api/editformsessions/' + record.id)
                    .then(response => {
                        this.isLoading = false;

                        this.lockedRecords.splice(index, 1);
                        this.showAlert('success', response.data.message);
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });
            },

            /**
             * Show alert
             */
            showAlert(alertClass, alertMessage) {
                this.alertClass = alertClass;
                this.alertMessage = alertMessage;
                this.alert = true;
            },
        }
    }

</script>
